<template>
	<b-modal
		id="success-modal"
		hide-footer
        hide-header
        centered
		size="md"
        @close="$emit('success-closed')"
	>
       
        <div style="text-align: center">
            <b-icon 
                :icon="'check-circle'" 
                style="width: 80px; height: 80px; margin: auto;"
                variant="success"
            />
            <p style="text-align: center"> {{ $t(successText) }}! </p>
            <b-button block variant="primary" @click="hideModal" squared>{{ $t("close") }}</b-button>
        </div>

	</b-modal>
</template>

<script>

export default {
	components: {
		
	},
	props: ["successText", "hideTime"],

	data() {
		return {

		};
	},

	created(){
		
	},

	methods: {
        hideModal() {
			this.$bvModal.hide("success-modal");
            this.$emit('success-closed')
		},

        autoHide(){
            const hideTime = this.hideTime ? this.hideTime : 3000;
            setTimeout(() => { this.hideModal(); }, hideTime);
        }

	}

};
</script>

<style lang="scss" scoped>

</style>